import {ApiResponse, PaginatedApiReponse} from '../models/ApiResponse';
import {
  CommentModel,
  CommentsListRequest,
} from '../models/Comments/CommentModel';
import {apiClient, withAuth} from './baseApiClient';

class CommentsAPI {
  public async createComment(
    entityId: string,
    text: string,
    parentCommentId?: string,
  ): Promise<ApiResponse<{commentId: string}>> {
    const headers = await withAuth({});
    return apiClient.post(
      '/comment',
      {entityId, text, parentCommentId},
      {headers},
    );
  }

  public async getComment(
    commentId: string,
  ): Promise<ApiResponse<CommentModel>> {
    const headers = await withAuth({});
    return apiClient.get(`/comment/${commentId}`, {headers});
  }

  public async editComment(
    commentId: string,
    text: string,
  ): Promise<ApiResponse<any>> {
    const headers = await withAuth({});
    return apiClient.put(`/comment/${commentId}`, {text}, {headers});
  }

  public async deleteComment(commentId: string): Promise<ApiResponse<any>> {
    const headers = await withAuth({});
    return apiClient.delete(`/comment/${commentId}`, {headers});
  }

  public async getEntityComments(
    entityId: string,
    request: CommentsListRequest,
  ): Promise<PaginatedApiReponse<CommentModel>> {
    const headers = await withAuth({});
    return apiClient.post(`/comment/entity/${entityId}/list`, request, {
      headers,
    });
  }

  public async getCommentReplies(
    commentId: string,
    request: CommentsListRequest,
  ): Promise<PaginatedApiReponse<CommentModel>> {
    const headers = await withAuth({});
    return apiClient.post(`/comment/${commentId}/replies`, request, {headers});
  }
}

export default CommentsAPI;
